import React from 'react'
import { useStore } from '../../../../hooks/useStore'

const CircularButton = ({children, onClick = null, size = 50, bgColor = "black", hoverColor="white", fillColor="black",  action, actionType = "action", noAction}) => {
    const {cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore()
    return (
        <div 
            className='circ-btn flex--center'
            onClick={() => {
                if (onClick) {
                    onClick()
                }
                handleMouseLeave()

            }}
            onMouseEnter={() => {
                if (noAction) return
                handleMouseEnter(actionType, action)
            }}
            onMouseLeave={()=> {
                if (noAction) return

                handleMouseLeave()
            }}
        >
            {children}


            <style jsx>{`   
                .circ-btn { 
                    width: ${size}px;
                    height: ${size}px;
                    border-radius: 50%;
                    background: ${bgColor};
                    transition: background .24s ease;
                }

                .circ-btn:hover {
                    background: ${hoverColor};
                }

                .circ-btn :global(svg) {
                    transition: background .24s ease;
                }

                .circ-btn:hover :global(svg) {
                    fill: ${fillColor};
                }
            `}</style>
        </div>
    )
}

export default CircularButton